let observer = []
let entriesData = new Map()

export function createObserver(headerHeight) {
    observer.forEach(threshold => {
        if (observer[threshold])
            observer[threshold].disconnect()
    })

    const InViewportCallback = entries => {
        for (let entry of entries) {
            const el = entry.target
            const entryData = entriesData.get(el)
            if (entry.isIntersecting) {
                requestAnimationFrame(() => {
                    if (entryData?.intersectingParent) {
                        entryData.intersectingParent.classList.add('InView')
                    } else {
                        el.classList.add('InView')
                    }

                    if (entryData.preloadVideo && entryData.videoElement && entryData.videoElement.preload !== 'auto') {
                        entryData.videoElement.preload = 'auto'
                        entryData.videoElement.load()
                    }
                })
            } else if (entryData?.triggerOnTopLeave || (!entryData?.triggerOnTopLeave && entry.intersectionRect.top > headerHeight)) {
                requestAnimationFrame(() => {
                    if (entryData?.intersectingParent) {
                        entryData.intersectingParent.classList.remove('InView')
                    } else {
                        el.classList.remove('InView')
                    }
                })
            }
        }
    }

    for (let i = 1; i <= 10; ++i) {
        const threshold = i / 10

        observer[threshold] = new IntersectionObserver(InViewportCallback, {
            root: null,
            rootMargin: `-${headerHeight}px 0px 0px 0px`,
            threshold,
        })
    }

    const InViewElements = document.getElementsByClassName('InViewportAnimate')
    requestAnimationFrame(() => {
        for (let InViewElement of InViewElements) {
            let threshold = parseFloat(InViewElement.getAttribute('data-threshold') || 0.3)
            if (isNaN(threshold) && Object.keys(observer).indexOf(String(threshold)) === -1) {
                threshold = 0.3
            }

            let intersectingParent = InViewElement.getAttribute('data-intersecting-parent') || undefined
            if (intersectingParent) {
                intersectingParent = InViewElement.closest(intersectingParent)
            }

            const preloadVideo = InViewElement.getAttribute('data-preload-video') === 'true'
            let videoElement = null
            if (preloadVideo) {
                videoElement = InViewElement.querySelector('video')
            }

            entriesData.set(InViewElement, {
                triggerOnTopLeave: InViewElement.getAttribute('data-trigger-on-top-leave') === 'true',
                preloadVideo,
                videoElement,
                intersectingParent: intersectingParent,
                threshold,
            })

            observer[threshold].observe(InViewElement)

            if (!intersectingParent) {
                intersectingParent = InViewElement
            }

            if (!intersectingParent.classList.contains('InViewportAnimateIn')) {
                intersectingParent.classList.add('InViewportAnimateIn')
            }

            InViewElement.style.opacity = 1
        }
    })
}
